import * as React from 'react';
import ECheckFilterBar from './ECheckFilterBar';
import ECheckTableDesktop from './ECheckTableDesktop';
import ECheckTableMobile from './ECheckTableMobile';
import {
  IPaymentFilters,
  IPagination
} from 'src/services/paySimple/paySimpleService';
import EcheckPaymentModel from 'src/model/echeckPayment.model';
import TablePaginator from 'src/components/common/TablePagination';

import './ManageECheck.scss';
import Loader from 'src/components/common/Loader';
import ECheckPermissions from './ECheckPermissions';

interface IManageECheckProps {
  data: any[];
  pageNumber: number;
  pageSize: number;
  totalElements: number;
  totalPages: number;
  isPending: number;
  selectedPayment: any;
  handlePaymentDetails: (payment: EcheckPaymentModel) => void;
  getPayments: (
    filters: IPaymentFilters,
    pagination: IPagination,
    sort?: any
  ) => void;
}

interface IManageECheckState {
  currentPage: number;
  status: 'AT' | 'DT';
  disposition: 'AW' | 'AD' | 'VT';
  desc: string;
  asc: string;
  sortColnameEcheck: string;
  sortByStrEcheck: string;
  openEcheckPermission : boolean;
}

class ManageECheck extends React.Component<
  IManageECheckProps,
  IManageECheckState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      currentPage: 0,
      status: null,
      disposition: null,
      desc: 'active',
      asc: '',
      sortColnameEcheck: 'paymentDate',
      sortByStrEcheck: 'paymentDate,desc',
      openEcheckPermission : false,
    };
  }

  public componentDidMount() {
    this.getPaymentsByPage(0);
  }

  private getFilteredPayments = (
    status: 'AT' | 'DT' | null,
    disposition: 'AW' | 'AD' | 'VT' | null
  ) => {
    const filters: IPaymentFilters = {
      status,
      disposition
    };

    // const pagination: IPagination = {
    //   page: 0
    // };

    // this.setState({
    //   status: filters.status,
    //   disposition: filters.disposition,
    //   currentPage: 0
    // });
    const pagination: IPagination = {
      page: this.state.currentPage
    };

    this.setState({
      status: filters.status,
      disposition: filters.disposition
    });
    this.props.getPayments(filters, pagination, this.state.sortByStrEcheck);
  };

  private getPaymentsByPage = (page: number) => {
    const filters: IPaymentFilters = {
      status: this.state.status,
      disposition: this.state.disposition,
      paymentDate: localStorage.getItem('searchPaymentDate'),
      userId: localStorage.getItem('searchFielda')
    };

    const pagination: IPagination = {
      page
    };
    this.props.getPayments(filters, pagination, this.state.sortByStrEcheck);
  };

  private handlePagination = (type: 'next' | 'previous') => {
    const { pageNumber, totalPages } = this.props;

    if (type === 'previous') {
      // if (pageNumber !== 0) {
      //   this.setState({ currentPage: this.state.currentPage + 1 }, () => {
      //     this.getPaymentsByPage(pageNumber - 1);
      //   });
      if (pageNumber !== 0) {
        this.setState({ currentPage: this.state.currentPage - 1 }, () => {
          this.getPaymentsByPage(pageNumber - 1);
        });
      }
    } else {
      // if (pageNumber !== totalPages) {
      //   this.setState({ currentPage: this.state.currentPage - 1 }, () => {
      //     this.getPaymentsByPage(pageNumber + 1);
      //   });
      if (pageNumber !== totalPages) {
        this.setState({ currentPage: this.state.currentPage + 1 }, () => {
          this.getPaymentsByPage(pageNumber + 1);
        });
      }
    }
  };

  private renderEcheckPermissions = () => {
    this.setState({ openEcheckPermission: !this.state.openEcheckPermission});
  }

  // cutomer code
  private handleSortedValEcheck = (colname: any) => {
    let sortBy = '';
    if (colname === this.state.sortColnameEcheck) {
      if (this.state.desc === 'active') {
        sortBy = colname + ',asc';
        this.setState({ desc: '', asc: 'active', sortByStrEcheck: sortBy });
      } else {
        sortBy = colname + ',desc';
        this.setState({ desc: 'active', asc: '', sortByStrEcheck: sortBy });
      }
    } else {
      sortBy = colname + ',desc';
      this.setState({
        sortColnameEcheck: colname,
        desc: 'active',
        asc: '',
        sortByStrEcheck: sortBy
      });
    }
    const filters: IPaymentFilters = {
      status: this.state.status,
      disposition: this.state.disposition
    };

    const pagination: IPagination = {
      page: this.state.currentPage
    };
    this.props.getPayments(filters, pagination, sortBy);
  };
  public render() {
    const pagination = {
      pageNumber: this.props.pageNumber,
      pageSize: this.props.pageSize,
      totalPages: this.props.totalPages
    };
    return (
      <>
      <div className="align-toggle-link">
      <a href="javascript:void(0)" onClick={() => this.renderEcheckPermissions()}> Toggle Echeck Payments / Echeck Permissions  </a></div>
      {this.state.openEcheckPermission && <ECheckPermissions />}
      {!this.state.openEcheckPermission && <div className="rp-manage-echeck container-fluid">
        <ECheckFilterBar
          handleFilteredPayments={this.getFilteredPayments}
          getPayments={this.props.getPayments}
          filter={{
            status: this.state.status,
            disposition: this.state.disposition
          }}
          pagination={{
            page: this.state.currentPage
          }}
          sort={this.state.sortByStrEcheck}
          pageNumber={this.props.pageNumber}
        />
        {this.props.isPending ? (
          <Loader />
        ) : (
          <React.Fragment>
            <div className="rp-manage-echeck-desktop">
              <ECheckTableDesktop
                payments={this.props.data}
                handleSortedValEcheck={this.handleSortedValEcheck}
                desc={this.state.desc}
                asc={this.state.asc}
                sortColnameEcheck={this.state.sortColnameEcheck}
              />
            </div>

            <div className="rp-manage-echeck-mobile">
              <ECheckTableMobile
                payments={this.props.data}
                selectedPayment={this.props.selectedPayment}
                handlePaymentDetails={this.props.handlePaymentDetails}
              />
            </div>

            <TablePaginator
              handlePagination={this.handlePagination}
              pagination={pagination}
            />
          </React.Fragment>
        )}
      </div>}
      </>
    );
  }
}

export default ManageECheck;
